import { checkUserHasAdminRole, checkUserHasBdmRole, checkUserHasManagerRole, checkUserHasMemberRole } from "app/services/app.state.service"
import ExportReportsView from "../export-reports/ExportReportsView";

export const ExportReportsRouterFactory = () => {

    // Members export their own timesheet only; managers export their own subtree; admins export
    // any member/manager in the system; a BDM exports the accounts they are the relationship
    // manager for (HRMS-116 point 7).
    // @since NEXT_VERSION
    if(checkUserHasMemberRole() || checkUserHasManagerRole() || checkUserHasAdminRole()
        || checkUserHasBdmRole()) {
        return <ExportReportsView />
    }
    else {
        window.location.href = "/login";
    }
}
